export enum PostType {
	BUILDER = 'builder',
	EFFECT_PASS = 'effectPass',
	TEXTURE = 'texture',
	UPDATE_SCENE = 'updateScene',
}
